var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('sectionHeader',{attrs:{"text":_vm.data.header}}),_vm._v(" "),_c('serviceGlyph',{attrs:{"service":_vm.service}}),_vm._v(" "),_c('sectionSummary',{attrs:{"text":_vm.data.summary}}),_vm._v(" "),_c('ulList',{attrs:{"header":_vm.data.listHeader,"list":_vm.data.list}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-626d4b49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/Service.vue
// module id = null
// module chunks = 